var translation = {
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less'
};
export default translation;